import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, MenuItem, Select, FormControl, InputLabel, Checkbox, FormControlLabel, Alert } from '@mui/material';

const UserSelectionDialog = ({ users, onSelect, onClose }) => {
  const [selectedUser, setSelectedUser] = useState('');
  const [remember, setRemember] = useState(false);
  const [isSelecting, setIsSelecting] = useState(false);
  const [error, setError] = useState('');

  const handleUserChange = (event) => {
    setSelectedUser(event.target.value);
  };

  const handleSelect = async () => {
    const user = users.find(user => user.emp_id === selectedUser);
    if (!user || isSelecting) return;
    setIsSelecting(true);
    setError('');
    try {
      await onSelect(user, remember);
    } catch {
      setError('Unable to load this account. Please try again.');
    } finally {
      setIsSelecting(false);
    }
  };

  return (
    <Dialog
      open
      onClose={isSelecting ? undefined : onClose}
      maxWidth="sm" // Set the maximum width of the dialog
      fullWidth // Ensure the dialog takes the full width
      sx={{ '& .MuiDialog-paper': { minHeight: '300px', minWidth: '300px' } }} // Custom styles for min height and width
    >
      <DialogTitle>Select An Account</DialogTitle>
      <DialogContent>
        <p style={{ marginBottom: '20px' }}>It looks like you have multiple user accounts on Fieldworker. Please select your account.</p>
        <FormControl fullWidth>
          <InputLabel id="user-select-label">User</InputLabel>
          <Select
            labelId="user-select-label"
            label="User"
            disabled={isSelecting}
            value={selectedUser}
            onChange={handleUserChange}
          >
            {users.map(user => (
              <MenuItem key={user.emp_id} value={user.emp_id}>
                {user.emp_first_name} {user.emp_last_name} ({user.com_name})
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControlLabel
          control={<Checkbox checked={remember} onChange={event => setRemember(event.target.checked)} disabled={isSelecting} />}
          label="Remember this account on this browser for 24 hours"
        />
        {error && <Alert severity="error">{error}</Alert>}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" disabled={isSelecting}>
          Cancel
        </Button>
        <Button onClick={handleSelect} color="primary" disabled={selectedUser === '' || isSelecting}>
          {isSelecting ? 'Selecting...' : 'Select'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserSelectionDialog;
